module.exports = __webpack_public_path__ + "static/media/kenziefy.f36b58b6.png";